import { Suspense, lazy } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { config } from '../config';

import { Routes } from './Routes';

// Components
import { NewsletterProvider } from './components/Footer';
import { Header } from './components/Header/Header';
import { Helmet } from './components/Helmet/Helmet';
import { WithInit } from './components/HOC/WithInit';
import { WithUrlParams } from './components/HOC/WithUrlParams';
import { OnRouteChange } from './components/OnRouteChange';
import { ThingsToDoProvider } from './pages/Browse/ThingsToDoProvider';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/navigation';
import { growthbook } from './experiments/growthBook';

export const App = () => {
  const Footer = lazy(() => import('../base/components/Footer').then((module) => ({ default: module.Footer })));

  // This is only here for us to test and evaluate
  // It acts as an AA test
  growthbook.isOn('test-feature');

  return (
    <div className="App">
      <AppHelmet />
      <Router>
        <OnRouteChange />
        <Header />
        <WithInit>
          <WithUrlParams>
            <NewsletterProvider>
              <ThingsToDoProvider>
                <Suspense fallback={<div />}>
                  <main>
                    <Routes />
                  </main>
                  <Footer />
                </Suspense>
              </ThingsToDoProvider>
            </NewsletterProvider>
          </WithUrlParams>
        </WithInit>
      </Router>
    </div>
  );
};

const AppHelmet = () => (
  <Helmet title={config['global.brandName']} href="" description={config['global.brandName']}>
    <meta name="theme-color" content="#008f68" />
    {config['awin.enable'] && (
      <script defer="defer" src={`https://www.dwin1.com/${config['awin.trackingId']}.js`} type="text/javascript" />
    )}
  </Helmet>
);
